// src/lib/proxyAuth.js
// The integrations API (Cloud Function `api`, URL in REACT_APP_JIRA_PROXY) only serves
// signed-in SPCC users. Rather than threading the Firebase ID token through every
// Jira/Slack call site, attach it here to requests bound for that API — and nowhere else.

export const PROXY_URL = (process.env.REACT_APP_INTEGRATIONS_API_URL || process.env.REACT_APP_JIRA_PROXY || 'https://me-west1-spcc-43642.cloudfunctions.net/api').replace(/\/$/, '')

const urlOf = (input) => (typeof input === 'string' ? input : input instanceof URL ? input.href : input?.url || '')

export function installProxyAuth() {
  if (process.env.REACT_APP_DB_PROVIDER !== 'firebase') return
  const nativeFetch = window.fetch.bind(window)
  window.fetch = async (input, init = {}) => {
    if (!urlOf(input).startsWith(`${PROXY_URL}/`)) return nativeFetch(input, init)
    const { getFirebaseUser } = await import('./firebase')
    const token = await (await getFirebaseUser())?.getIdToken()
    if (!token) return nativeFetch(input, init)
    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined))
    if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${token}`)
    return nativeFetch(input, { ...init, headers })
  }
}
